export type LiveStatus = "online" | "offline" | "testing";

const STATUS_DOT_CLASS: Record<LiveStatus, string> = {
  online: "bg-emerald-500",
  offline: "bg-destructive",
  testing: "bg-amber-500 animate-pulse",
};

type Props = {
  status: LiveStatus;
  size?: "xs" | "sm";
  ringClassName?: string;
  title?: string;
};

const SIZE_CLASS: Record<NonNullable<Props["size"]>, string> = {
  xs: "size-1.5",
  sm: "size-2",
};

const StatusDot = ({
  status,
  size = "xs",
  ringClassName,
  title,
}: Props) => {
  return (
    <span
      title={title}
      className={`inline-block rounded-full ${SIZE_CLASS[size]} ${STATUS_DOT_CLASS[status]} ${ringClassName ?? ""}`}
    />
  );
};

export default StatusDot;
